import React, {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {post} from "../../utils/FetchUtil.ts";
import {useLoading} from "../loading/LoadingProvider.tsx";
interface AuthContextType {
    isAuthLoading: boolean;
    isAuthenticated: boolean;
    loginDto: LoginInfoDto | undefined;
    login: (loginData: LoginInfoDto | undefined) => void;
    logout: () => void;
    updateLogin: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
interface AuthProviderProps {
    children: ReactNode;
}
export const AuthProvider:React.FC<AuthProviderProps> = ({children}) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const { showLoading, hideLoading } = useLoading();
    const [loginDto, setLoginDto] = useState<AuthContextType['loginDto']>(undefined);
    const login = (loginData: AuthContextType['loginDto']) => {
        if(loginData?.logged_in){
            setIsAuthenticated(true);
            setLoginDto(loginData);
        }else{
            setIsAuthenticated(false);
            setLoginDto(undefined);
        }
    }
    const logout = () => {
        setIsAuthenticated(false);
        setLoginDto(undefined);
        // navigate('/login');
    }
    const updateLogin = () => {
        validLogin();
    };
    const validLogin = () => {
        setIsAuthLoading(true);
        getSessionLoginInfo()
            .finally(() => setIsAuthLoading(false));
    }
    const getSessionLoginInfo = async () => {
        showLoading();
        try{
            const resData = await post<LoginInfoDto>({
                action: "/api/login/logged_in/info",
                data: {},
            });
            login(resData);
        }catch (error) {
            console.error("セクション情報取得の例外:", error);
            login(undefined);
        }finally {
            hideLoading();
            setIsAuthLoading(false);
        }
    };
    useEffect(() => {
        validLogin();
    }, []);
    const value: AuthContextType = {
        isAuthLoading,
        isAuthenticated,
        loginDto,
        login,
        logout,
        updateLogin
    };
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if(context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};